import { Tag, TagLabel, Box, Tooltip, TagProps } from '@chakra-ui/react';
import { ITag } from 'types';
import { PathwayIndicator } from '../../../atoms/icons/PathwayIndicator';
import { useTranslation } from "react-i18next";

export const PathwayTag = ({ tag, tagProps }: { tag: ITag; tagProps?: TagProps }) => {
  return (
    <Tooltip hasArrow placement="bottom" label={<PathwayHover pathwayUni={tag.pathwayUni!} />}>
      <Tag size="xs" variant="solid" data-selector="tag-pathway" {...tagProps}>
        <Box mr="0.5">
          <PathwayIndicator />
        </Box>

        <TagLabel>{tag.label}</TagLabel>
      </Tag>
    </Tooltip>
  );
};

const PathwayHover = ({ pathwayUni }: { pathwayUni: string }) => {
    const { t } = useTranslation('common');
  return (
    <Box>
      {t('common:pathwayStudent')}
                <br />
      <b>{pathwayUni}</b>
    </Box>
  );
};
